var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tags.length > 0)?_c('multi-tags',_vm._b({attrs:{"tags":_vm.options.showMissing ? _vm.tagsWithMissing : _vm.tags,"class-joiner":'num-players',"tag-formatter":_vm.formatTag}},'multi-tags',_vm.options,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }